import React, { useContext } from 'react'
import ProgressIndicator, {
  ProgressIndicatorInterface
} from '@veneer/core/dist/scripts/progress_indicator'
import { useAssetImport } from './useAssetImport'
import { MfeComponentContext } from './types'
import * as S from './styles'
import { useSignupSession } from '../../hooks'
import { buildThemeSettings } from './themeSettings'

export const MfeLoader = () => {
  const { isHpx } = useSignupSession()
  const { name, props, packageName = '@jarvis' } = useContext(
    MfeComponentContext
  )
  const { isLoading, mfe } = useAssetImport(`${packageName}/${name}`)
  const loadingAppearance = props?.loadingAppearance || 'circular'

  if (isLoading && loadingAppearance !== 'none') {
    return (
      <S.LoadingContainer>
        <ProgressIndicator
          appearance={
            loadingAppearance as ProgressIndicatorInterface['appearance']
          }
        />
      </S.LoadingContainer>
    )
  }

  if (mfe?.default) {
    const updatedProps = {
      ...props,
      themeSettings: buildThemeSettings(
        isHpx,
        props?.themeSettings as Record<string, unknown> | undefined
      )
    }

    return <mfe.default properties={updatedProps} />
  }

  if (loadingAppearance === 'none' && isLoading) return null

  return <div>MFE not found</div>
}
